import React, { createContext, useState, useContext, useEffect } from 'react';
import * as api from '../services/api';
import { useAuth } from './AuthContext';

const ModulesContext = createContext(null);

export const ModulesProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      loadModules();
    } else {
      setModules([]);
      setLoading(false);
    }
  }, [user]);

  const loadModules = async () => {
    try {
      const res = await api.getModulesOrder();
      setModules(res.data.modules || []);
    } catch {
      setModules([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModulesContext.Provider value={{ modules, loading, refreshModules: loadModules }}>
      {children}
    </ModulesContext.Provider>
  );
};

export const useModules = () => {
  const ctx = useContext(ModulesContext);
  if (!ctx) throw new Error('useModules must be within ModulesProvider');
  return ctx;
};
